module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-manager"
  }, [_c('div', {
    staticClass: "white-box order-manager-table"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("订单列表")]), _vm._v(" "), _c('table', {
    staticClass: "xmly-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.orderTableData), function(order) {
    return _c('tbody', {
      key: order.orderNo
    }, [_c('tr', {
      staticClass: "order"
    }, [_c('td', [_vm._v(_vm._s(("订单编号：" + (order.orderNo))))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "column-content"
    }, [_c('div', {
      staticClass: "pic"
    }, [_c('img', {
      attrs: {
        "src": order.coverUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('h2', {
      staticClass: "tit elli"
    }, [_vm._v(_vm._s(order.commodityName))]), _vm._v(" "), _c('p', {
      staticClass: "price elli"
    }, [_vm._v(_vm._s(("售价：￥" + (order.orderAmount))))])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.commodityType))]), _vm._v(" "), _c('td', [_c('p', {
      staticClass: "name elli"
    }, [_vm._v(_vm._s(order.buyerNickName))]), _vm._v(" "), _c('p', {
      staticClass: "tel elli"
    }, [_vm._v(_vm._s(order.buyerMobile))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.orderStatus == 2 ? '订单成功' : (order.orderStatus == 5 ? '已退款' : '')) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("￥" + (order.orderAmount))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.rate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(("￥" + (order.brokerageAmount))))]), _vm._v(" "), (_vm.promotorType == 1) ? _c('td', [_vm._v(_vm._s(order.promotorName.split('-')[0] == '城市合伙人' ? ("城市服务商-" + (order.promotorName.split('-')[1])) : order.promotorName))]) : _vm._e(), _vm._v(" "), (_vm.promotorType == 2) ? _c('td', [_vm._v(_vm._s(order.promotorName.split('-')[1]))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.createdAt))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "order-manager-pag column-content white-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.curPage = $event
      }
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("商品类型")]), _vm._v(" "), _c('th', [_vm._v("用户")]), _vm._v(" "), _c('th', [_vm._v("订单状态")]), _vm._v(" "), _c('th', [_vm._v("订单金额（元）")]), _vm._v(" "), _c('th', [_vm._v("分成比例")]), _vm._v(" "), _c('th', [_vm._v("佣金（元）")]), _vm._v(" "), _c('th', [_vm._v("渠道")]), _vm._v(" "), _c('th', [_vm._v("创建时间")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e42d3dea","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/orderManager/lock.vue
// module id = 951
// module chunks = 1